import React, { useState } from 'react';
import '../../asstes/css/sass/Sidebar.scss';
import { Link } from 'react-router-dom';

const navItems = [
  { to: '/USA/upcomingevents', icon: 'fa-calendar-alt', label: 'Events' },
  { to: '/USA/activitycalendar', icon: 'fa-calendar-check', label: 'Calendar' },
  { to: '/USA/wordsofwisdom', icon: 'fa-book-open', label: 'Wisdom' },
  { to: 'https://donationusa.yugalkunj.org/rms/', icon: 'fa-hand-holding-heart', label: 'Donate', external: true },
];

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <>
      {/* ── Desktop right-side floating panel ── */}
      <div className={`yk-sidebar-desktop ${isCollapsed ? 'yk-sidebar-hidden' : ''}`}>
        <button
          className="yk-sidebar-toggle"
          onClick={() => setIsCollapsed(p => !p)}
          aria-label={isCollapsed ? 'Show menu' : 'Hide menu'}
        >
          <i className={`fas ${isCollapsed ? 'fa-chevron-left' : 'fa-chevron-right'}`}></i>
          <span>{isCollapsed ? 'Show' : 'Hide'}</span>
        </button>

        <div className="yk-sidebar-panel">
          {navItems.map((item) =>
            item.external ? (
              <a
                key={item.label}
                href={item.to}
                className="yk-sidebar-item"
                target="_blank"
                rel="noreferrer"
              >
                <i className={`fas ${item.icon}`}></i>
                <span>{item.label}</span>
              </a>
            ) : (
              <Link key={item.label} className="yk-sidebar-item" to={item.to}>
                <i className={`fas ${item.icon}`}></i>
                <span>{item.label}</span>
              </Link>
            )
          )}
        </div>
      </div>

      {/* ── Mobile bottom dock (always visible) ── */}
      <nav className="yk-bottom-nav" aria-label="Quick navigation">
        {navItems.map((item) =>
          item.external ? (
            <a
              key={item.label}
              href={item.to}
              className="yk-bottom-nav-item"
              target="_blank"
              rel="noreferrer"
            >
              <i className={`fas ${item.icon}`}></i>
              <span>{item.label}</span>
            </a>
          ) : (
            <Link key={item.label} className="yk-bottom-nav-item" to={item.to}>
              <i className={`fas ${item.icon}`}></i>
              <span>{item.label}</span>
            </Link>
          )
        )}
      </nav>
    </>
  );
};

export default Sidebar;
